const PromptSimLoader = () => {
    return (
        <div className="prompts_simulation_run_queued_cont_prompts_loading">
            <div className="prompts_simulation_run_queued_cont_prompts_loading_item fade-in"></div>
            <div className="prompts_simulation_run_queued_cont_prompts_loading_item fade-in"></div>
            <div className="prompts_simulation_run_queued_cont_prompts_loading_item fade-in"></div>
        </div>
    )
}

export default PromptSimLoader